// extracted by css-extract-rspack-plugin
var _1 = "nf";
export { _1 as "emailConfirmationComponent" }
